import React from "react";

function Icon(props) {
  return (
    <div className={props.className} style={{padding: "4px", margin: "-4px"}}>
      <svg
        height={props.height}
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        strokeLinejoin="round"
        strokeMiterlimit="2"
        clipRule="evenodd"
        viewBox="0 0 213 268"
      >
        <path
          className={props.pathClass ? props.pathClass : "g1-fill"}
          d="M10837.3 2500.05h-19.7c-2.6 0-4.8-1.99-5-4.57-2.2-25.44-13-149.56-15.4-177.13-.2-1.4.3-2.78 1.2-3.82 1-1.03 2.3-1.62 3.7-1.62h179.3c1.4 0 2.8.59 3.7 1.62 1 1.04 1.4 2.42 1.3 3.82-2.4 27.57-13.2 151.69-15.4 177.13-.3 2.58-2.4 4.57-5 4.57h-19.7s10.3-118.37 12.6-145.36c.2-1.39-.3-2.78-1.3-3.81-.9-1.03-2.2-1.62-3.6-1.62h-4.6c-2.6 0-4.8 1.98-5 4.56-2.2 25.21-12.8 146.23-12.8 146.23h-32.5v-145.79c0-1.33-.5-2.6-1.5-3.54-.9-.94-2.2-1.46-3.5-1.46h-4.6c-1.3 0-2.6.52-3.5 1.46-1 .94-1.5 2.21-1.5 3.54v145.79h-32.5s-10.6-121.02-12.8-146.23c-.2-2.58-2.4-4.56-5-4.56h-4.6c-1.4 0-2.7.59-3.7 1.62-.9 1.03-1.4 2.42-1.3 3.81 2.4 26.99 12.7 145.36 12.7 145.36zm71.3-267.03c9.9 0 17.9 8.02 17.9 17.91v11.94h65.1c3.6 0 6.5 3.67 6.5 8.2v19.4c0 4.52-2.9 8.2-6.5 8.2H10792c-3.6 0-6.5-3.68-6.5-8.2v-19.4c0-4.53 2.9-8.2 6.5-8.2h65.1v-11.94c0-9.89 8-17.91 17.9-17.91h33.6zm0 14.59h-33.6c-1.8 0-3.3 1.48-3.3 3.32v11.94h40.2v-11.94c0-1.84-1.5-3.32-3.3-3.32z"
          transform="translate(-10785.5 -2233.02)"
        ></path>
      </svg>
    </div>
  );
}

export default Icon;
